import { render, staticRenderFns } from "./payable-balance-result-maintenance.vue?vue&type=template&id=3b2c1b6b&"
import script from "./payable-balance-result-maintenance.vue?vue&type=script&lang=js&"
export * from "./payable-balance-result-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports